import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../config/firebase';

export interface UploadResult {
  success: boolean;
  url?: string;
  error?: string;
}

export const uploadBusinessLogo = async (
  file: File, 
  businessId: string
): Promise<UploadResult> => {
  try {
    console.log('Debug - Upload service - businessId:', businessId);
    console.log('Debug - Upload service - file:', file.name, file.size, file.type);
    
    // Validar el archivo
    if (!file) {
      return { success: false, error: 'No se seleccionó ningún archivo' };
    }

    // Validar el tipo de archivo
    if (!file.type.startsWith('image/')) {
      return { success: false, error: 'El archivo debe ser una imagen' };
    }

    // Validar el tamaño (5MB máximo)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      return { success: false, error: 'El archivo es demasiado grande. Máximo 5MB' };
    }

    // Crear referencia al archivo en Storage
    const fileName = `logo_${Date.now()}_${file.name}`;
    const storageRef = ref(storage, `businesses/${businessId}/logo/${fileName}`);
    
    console.log('Debug - Upload service - Storage path:', `businesses/${businessId}/logo/${fileName}`);

    // Subir el archivo
    const snapshot = await uploadBytes(storageRef, file);
    
    // Obtener la URL de descarga
    const downloadURL = await getDownloadURL(snapshot.ref);

    return { success: true, url: downloadURL };
  } catch (error) {
    console.error('Error uploading business logo:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Error al subir la imagen' 
    };
  }
};

export const deleteBusinessLogo = async (
  businessId: string,
  fileName: string
): Promise<UploadResult> => {
  try {
    const storageRef = ref(storage, `businesses/${businessId}/logo/${fileName}`);
    await deleteObject(storageRef);
    return { success: true };
  } catch (error) {
    console.error('Error deleting business logo:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Error al eliminar la imagen' 
    };
  }
};

export const extractFileNameFromUrl = (url: string): string | null => {
  try {
    const urlObj = new URL(url);
    const pathParts = urlObj.pathname.split('/');
    return pathParts[pathParts.length - 1];
  } catch {
    return null;
  }
}; 